import React from 'react';
import Link from 'gatsby-link';

import logo from '../assets/images/marcos-logo-reverse.svg';

class Header extends React.Component {
  updateBody = toExpand => {
    // special case for static page render
    if (typeof window === 'undefined') { return; }

    const expandMethod = toExpand ? 'add' : 'remove';
    const collapseMethod = !toExpand ? 'add' : 'remove';
    window.document.body.classList[expandMethod]('nav-expanded');
    window.document.body.classList[collapseMethod]('nav-collapsed');
  }

  adaptNavigation = e => {
    if (this.props.overlayActive !== e.matches) {
      this.props.onNavToggle(e.matches);
    }
  }

  toggleNavigation = () => {
    this.updateBody(!this.props.overlayActive);
    this.props.onNavToggle(!this.props.overlayActive);
  }

  componentDidMount() {
    // special case for static page render
    if (typeof window === 'undefined') { return; }

    // media query list for: medium up
    this.mediaQL = window.matchMedia('(min-width: 40em)');
    this.mediaQL.addListener(this.adaptNavigation);
    this.adaptNavigation(this.mediaQL);
  }

  componentWillUnmount() {
    this.mediaQL.removeListener(this.adaptNavigation);
  }

  componentWillUpdate(nextProps) {
    if (this.props.overlayActive !== nextProps.overlayActive) {
      this.updateBody(nextProps.overlayActive);
    }
  }

  render() {
    const { id, siteTitle } = this.props;
    let navAriaProps = {
      ['aria-expanded']: this.props.overlayActive,
      ['aria-label']: 'Main menu',
    };

    return (
      <div className="content-wrapper" data-for="page-header">
        <header id={id}>
          <Link className="logo-link" to="/"><img src={logo} alt="Marcos Abreu - web architect/engineer" width="95" height="90" /></Link>
        </header>

        {/* button element for accessibility: will be hidden for: medium up */}
        <button
          id="main-menu-toggle"
          onClick={this.toggleNavigation}
          className="menu-toggle"
          type="button"
          aria-expanded={navAriaProps['aria-expanded']}
          aria-controls="main-menu"
          aria-label="Toggle main menu"><span>Toggle main menu</span></button>
        <nav id="main-menu" { ...navAriaProps }>
          <ul>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/portfolio">Portfolio</Link></li>
            <li><Link to="/blog">Blog</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </nav>
      </div>
    );
  }
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js